<mat-card style="padding: 0px;">
    <mat-card-header>
        <mat-card-title>Tabela de Classificação de Severidade da Seca</mat-card-title>

    </mat-card-header>

    <mat-divider></mat-divider>

    <mat-card-content>
        <h4>Resumo de descrição dos mapas</h4>
        <p style="text-align: justify">
          <strong> S0-S4:</strong> O Monitor de Secas apresenta uma legenda que categoriza as regiões afetadas pela seca, classificando-as de S0 (menos intensa) a S4 (mais intensa). As secas fraca (S0) e moderada (S1) possuem, estatisticamente, um tempo de retorno menor, sendo, portanto, mais frequentes no mapa. Por outro lado, as demais categorias de seca (S2, S3 e S4) enquadram-se como eventos mais “raros”, com tempos de retorno superiores a 10 anos.
          <br /><br />
          <strong>C e L:</strong> Essas letras evidenciam de que maneira a seca gera impactos ao longo do tempo, afetando as esferas social, ambiental e econômica.
          <br /><br />

          <strong style="margin-left: 20px;">C</strong> = Seca de Curto Prazo, normalmente atuando por menos de 8 meses (ex. impactos na agricultura)<br />
          <strong  style="margin-left: 20px;">L</strong> = Seca de Longo Prazo, normalmente atuando por mais de 9 meses (ex. impactos na hidrologia e ecologia)

        </p>

        <div class="dirtfade"></div>

        <!-- tabela NE -->
        <mat-card class="example-card" appearance="outlined">
          <mat-card-header>
            <mat-card-title>Tabela Severidade NE</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <table class="table-severidade" cellpadding="2" cellspacing="0" width="100%">
              <tbody>

                <tr>
                  <td class="width-cols">
                    <p><strong>Categoria</strong></p>
                  </td>
                  <td class="width-cols">
                    <p><strong>Descrição</strong></p>
                  </td>
                  <td class="width-cols">
                    <p><strong>Percentil</strong></p>
                  </td>
                  <td class="width-cols">
                    <p><strong>SPI/SPEI</strong></p>
                  </td>
                  <td class="width-cols">
                    <p><strong>Recorrência</strong></p>
                  </td>
                  <td>
                    <p><strong>Impactos Possíveis nos estados da Região Nordeste</strong></p>
                  </td>
                </tr>

                <tr class="row-s0">
                  <td>
                      <p><strong>S0</strong></p>
                  </td>
                  <td>
                      <p>Seca Fraca</p>
                  </td>
                  <td>
                      <p>30 %til</p>
                  </td>
                  <td>
                    <p>-0,5 a -0,79</p>
                  </td>
                  <td>
                    <p>Uma vez a cada <span style="white-space: nowrap;">2-5 anos</span></p>
                  </td>
                  <td class="margem-impactos">
                      <p>Entrando em seca (curto prazo): veranico atrasando plantio; possibilidade de leve redução na produção de culturas/pastagens;  redução no nível de pequenos reservatórios durante a estação chuvosa; 
Saindo de seca (longo prazo): alguns déficits hídricos prolongados (especialmente em reservatórios maiores); culturas/pastagens não completamente recuperadas.</p>
                  </td>
              </tr>


              <tr class="row-s1">
                <td >
                    <p><strong>S1</strong></p>
                </td>
                <td>
                    <p>Seca Moderada</p>
                </td>
                <td>
                    <p>20 %til</p>
                </td>
                <td>
                  <p>-0,8 a -1,29</p>
                </td>
                <td>
                  <p>Uma vez a cada <span style="white-space: nowrap;">5-10 anos</span></p>
                </td>
                <td class="margem-impactos">
                    <p>Alguns danos às culturas;  diminuição das pastagens e/ou perda da qualidade da forragem; emagrecimento ou retardo na engorda do gado; reservatórios, rios ou poços com níveis decrescentes; redução da disponibilidade hídrica em comunidades rurais.</p>
                </td>
            </tr>

            <tr class="row-s2">
              <td>
                  <p><strong>S2</strong></p>
              </td>
              <td>
                  <p>Seca Grave</p>
              </td>
              <td>
                  <p>10 %til</p>
              </td>
              <td>
                <p>-1,3 a -1,59</p>
              </td>
              <td>
                <p>Uma vez a cada <span style="white-space: nowrap;">10-20 anos</span></p>
              </td>
              <td class="margem-impactos">
                  <p>Perdas de culturas; graves danos às pastagens; prejuízos à agricultura familiar; desnutrição do gado; escassez de água (níveis baixos) em reservatórios, rios ou poços; alguns problemas de abastecimento em sedes municipais; restrições<sup>1</sup> de água impostas.</p>
              </td>
            </tr>

          <tr class="row-s3">
              <td>
                  <p><strong>S3</strong></p>
              </td>
              <td>
                  <p>Seca Extrema</p>
              </td>
              <td>
                  <p>5 %til</p>
              </td>
              <td>
                <p>-1,6 a -1,99</p>
              </td>
              <td>
                <p>Uma vez a cada <span style="white-space: nowrap;">20-50 anos</span></p>
              </td>
              <td class="margem-impactos">
                  <p>Grandes perdas de culturas/pastagens; mortandade animal; ameaça à subsistência em comunidades rurais; escassez grave de água e/ou aumento das restrições<sup>2</sup> de uso.</p>
              </td>
          </tr>

          <tr class="row-s4">
              <td>
                  <p><strong>S4</strong></p>
              </td>
              <td>
                  <p>Seca Excepcional</p>
              </td>
              <td>
                  <p>2 %til</p>
              </td>
              <td>
                <p><-2</p>
              </td>
              <td>
                <p>Uma vez a cada <span style="white-space: nowrap;">50-100 anos</span></p>
              </td>
              <td class="margem-impactos">
                  <p>Perdas excepcionais e generalizadas de culturas/pastagens; mortandade animal (inclusive silvestres), com grandes prejuízos econômicos; grave insegurança alimentar em comunidades rurais; escassez generalizada de água nos reservatórios, rios e poços, requerendo abastecimento emergencial (inclusive em sedes municipais).</p>
              </td>
          </tr>

              </tbody>
        </table>
        <p style="font-size: 12px; font-style: italic;"><b>1</b> Exemplos de restrições: rodízio ou racionamento de água, revisão de outorgas para priorizar o abastecimento humano e dessedentação animal, etc.</p>
        <p style="font-size: 12px; font-style: italic;"><b>2</b> Exemplos de restrições: suspensão de outorgas, apreensão de bombas, etc.</p>
          </mat-card-content>
          
        </mat-card>
        <p></p>

        <!-- tabela CO/N -->
        <mat-card class="example-card" appearance="outlined">
          <mat-card-header>
            <mat-card-title>Tabela Severidade CO/N</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <table class="table-severidade" cellpadding="2" cellspacing="0" width="100%">
              <tbody>

                <tr>
                  <td class="width-cols">
                    <p><strong>Categoria</strong></p>
                  </td>
                  <td class="width-cols">
                    <p><strong>Descrição</strong></p>
                  </td>
                  <td class="width-cols">
                    <p><strong>Percentil</strong></p>
                  </td>
                  <td class="width-cols">
                    <p><strong>SPI/SPEI</strong></p>
                  </td>
                  <td class="width-cols">
                    <p><strong>Recorrência</strong></p>
                  </td>
                  <td>
                    <p><strong>Impactos Possíveis nos estados das Regiões Centro-Oeste e Norte do Brasil</strong></p>
                  </td>
                </tr>

                <tr class="row-s0">
                  <td>
                      <p><strong>S0</strong></p>
                  </td>
                  <td>
                      <p>Seca Fraca</p>
                  </td>
                  <td>
                      <p>30 %til</p>
                  </td>
                  <td>
                    <p>-0,5 a -0,79</p>
                  </td>
                  <td>
                    <p>Uma vez a cada <span style="white-space: nowrap;">2-5 anos</span></p>
                  </td>
                  <td class="margem-impactos">
                      <p>Entrando em seca (curto prazo): veranico atrasando plantio; possibilidade de pequenas perdas de culturas/pastagens. 
                          Saindo de seca (longo prazo): alguns déficits hídricos prolongados; culturas/pastagens não completamente recuperadas; alguns déficits de precipitação em 12, 18 ou 24 meses.</p>
                  </td>
              </tr>


              <tr class="row-s1">
                <td >
                    <p><strong>S1</strong></p>
                </td>
                <td>
                    <p>Seca Moderada</p>
                </td>
                <td>
                    <p>20 %til</p>
                </td>
                <td>
                  <p>-0,8 a -1,29</p>
                </td>
                <td>
                  <p>Uma vez a cada <span style="white-space: nowrap;">5-10 anos</span></p>
                </td>
                <td class="margem-impactos">
                    <p>Alguns danos às culturas/pastagens, com perdas prováveis; córregos, igarapés, reservatórios ou poços com níveis baixos; algumas faltas de água em desenvolvimento ou iminentes; aumento no número de focos de calor; risco moderado para incêndios florestais; dificuldades na navegação. 
Seca em regressão (longo prazo): déficits de precipitação importantes em 18 e 24 meses</p>
                </td>
            </tr>

            <tr class="row-s2">
              <td>
                  <p><strong>S2</strong></p>
              </td>
              <td>
                  <p>Seca Grave</p>
              </td>
              <td>
                  <p>10 %til</p>
              </td>
              <td>
                <p>-1,3 a -1,59</p>
              </td>
              <td>
                <p>Uma vez a cada <span style="white-space: nowrap;">10-20 anos</span></p>
              </td>
              <td class="margem-impactos">
                  <p>Perdas consideráveis de culturas/pastagens; escassez de água em bacias críticas; restrições<sup>*</sup> de água impostas; aumento no número de incêndios florestais; comprometimento da navegação.
Seca em regressão (longo prazo): déficits de precipitação importantes em 12, 18 e 24 meses</p>
              </td>
            </tr>

          <tr class="row-s3">
              <td>
                  <p><strong>S3</strong></p>
              </td>
              <td>
                  <p>Seca Extrema</p>
              </td>
              <td>
                  <p>5 %til</p>
              </td>
              <td>
                <p>-1,6 a -1,99</p>
              </td>
              <td>
                <p>Uma vez a cada <span style="white-space: nowrap;">20-50 anos</span></p>
              </td>
              <td class="margem-impactos">
                  <p>Grandes perdas de culturas/pastagens; mortandade animal; escassez de água generalizada e/ou aumento das restrições de uso; incêndios florestais duradouros e/ou de grandes proporções; impactos na qualidade do ar e efeitos adversos à saúde; comunidades rurais/tradicionais isoladas (navegação)</p>
              </td>
          </tr>

          <tr class="row-s4">
              <td>
                  <p><strong>S4</strong></p>
              </td>
              <td>
                  <p>Seca Excepcional</p>
              </td>
              <td>
                  <p>2 %til</p>
              </td>
              <td>
                <p><-2</p>
              </td>
              <td>
                <p>Uma vez a cada <span style="white-space: nowrap;">50-100 anos</span></p>
              </td>
              <td class="margem-impactos">
                  <p>Perdas excepcionais e generalizadas de culturas/ pastagens;  escassez de água nos reservatórios, rios e poços, criando situações de emergência, inclusive em centros urbanos;  recordes no número de incêndios florestais, com grande perda na biodiversidade e impactos na qualidade do ar e saúde da população; interrupção da navegação.</p>
              </td>
          </tr>

              </tbody>
        </table>
        <p style="font-size: 12px; font-style: italic;"><b>*</b> Exemplos de restrições: rodízio ou racionamento de água, revisão ou suspensão de outorgas para priorizar o abastecimento humano e dessedentação animal, etc.</p>
          </mat-card-content>
          
        </mat-card>
        <p></p>

        <!-- tabela S/SE -->
        <mat-card class="example-card" appearance="outlined">
          <mat-card-header>
            <mat-card-title>Tabela Severidade S/SE</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <table class="table-severidade" cellpadding="2" cellspacing="0" width="100%">
              <tbody>

                <tr>
                  <td class="width-cols">
                    <p><strong>Categoria</strong></p>
                  </td>
                  <td class="width-cols">
                    <p><strong>Descrição</strong></p>
                  </td>
                  <td class="width-cols">
                    <p><strong>Percentil</strong></p>
                  </td>
                  <td class="width-cols">
                    <p><strong>SPI/SPEI</strong></p>
                  </td>
                  <td class="width-cols">
                    <p><strong>Recorrência</strong></p>
                  </td>
                  <td>
                    <p><strong>Impactos Possíveis nos estados das Regiões Sudeste e Sul</strong></p>
                  </td>
                </tr>

                <tr class="row-s0">
                  <td>
                      <p><strong>S0</strong></p>
                  </td>
                  <td>
                      <p>Seca Fraca</p>
                  </td>
                  <td>
                      <p>30 %til</p>
                  </td>
                  <td>
                    <p>-0,5 a -0,79</p>
                  </td>
                  <td>
                    <p>Uma vez a cada <span style="white-space: nowrap;">2-5 anos</span></p>
                  </td>
                  <td class="margem-impactos">
                      <p>Entrando em seca (curto prazo): veranico atrasando plantio; possibilidade de leve redução na produção de culturas/pastagens; redução no nível de pequenos reservatórios durante a estação chuvosa; 
Saindo de seca (longo prazo): alguns déficits hídricos prolongados; dificuldades na captação em regiões de cabeceira; culturas/pastagens não completamente recuperadas.</p>
                  </td>
              </tr>


              <tr class="row-s1">
                <td >
                    <p><strong>S1</strong></p>
                </td>
                <td>
                    <p>Seca Moderada</p>
                </td>
                <td>
                    <p>20 %til</p>
                </td>
                <td>
                  <p>-0,8 a -1,29</p>
                </td>
                <td>
                  <p>Uma vez a cada <span style="white-space: nowrap;">5-10 anos</span></p>
                </td>
                <td class="margem-impactos">
                    <p>Alguns danos às culturas/pastagens;  diminuição das pastagens e/ou perda da qualidade da forragem; emagrecimento ou retardo na engorda do gado, com possível diminuição na produção de leite; risco moderado de incêndios florestais; reservatórios, rios ou poços com níveis decrescentes; restrições na operação de PCH´s; revisão das regras de uso para irrigação; redução da disponibilidade hídrica em comunidades rurais.</p>
                </td>
            </tr>

            <tr class="row-s2">
              <td>
                  <p><strong>S2</strong></p>
              </td>
              <td>
                  <p>Seca Grave</p>
              </td>
              <td>
                  <p>10 %til</p>
              </td>
              <td>
                <p>-1,3 a -1,59</p>
              </td>
              <td>
                <p>Uma vez a cada <span style="white-space: nowrap;">10-20 anos</span></p>
              </td>
              <td class="margem-impactos">
                  <p>Perdas de culturas (estimadas em milhões de reais); graves danos às pastagens; prejuízos à agricultura familiar; desnutrição do gado com eventuais mortes; escassez de água em reservatórios, rios ou poços; comprometimento dos níveis de qualidade da água; alguns problemas de abastecimento em sedes municipais; restrições<sup>1</sup> de água impostas; aumento no risco ou propagação de incêndios florestais; proibição da prática de queima controlada; baixa qualidade do ar em grandes centros urbanos em decorrência do acúmulo de material particulado na atmosfera; proibição parcial da atividade pesqueira.</p>
              </td>
            </tr>

          <tr class="row-s3">
              <td>
                  <p><strong>S3</strong></p>
              </td>
              <td>
                  <p>Seca Extrema</p>
              </td>
              <td>
                  <p>5 %til</p>
              </td>
              <td>
                <p>-1,6 a -1,99</p>
              </td>
              <td>
                <p>Uma vez a cada <span style="white-space: nowrap;">20-50 anos</span></p>
              </td>
              <td class="margem-impactos">
                  <p>Grandes perdas de culturas/pastagens (estimadas em bilhões de reais); mortandade animal; escassez grave de água e/ou aumento das restrições<sup>2</sup> de uso; ameaça à segurança alimentar em comunidades rurais; Redução expressiva da capacidade de geração de energia hidroelétrica; Proibição generalizada da atividade pesqueira.</p>
              </td>
          </tr>

          <tr class="row-s4">
              <td>
                  <p><strong>S4</strong></p>
              </td>
              <td>
                  <p>Seca Excepcional</p>
              </td>
              <td>
                  <p>2 %til</p>
              </td>
              <td>
                <p><-2</p>
              </td>
              <td>
                <p>Uma vez a cada <span style="white-space: nowrap;">50-100 anos</span></p>
              </td>
              <td class="margem-impactos">
                  <p>Perdas excepcionais e generalizadas em diversos setores produtivos, com grandes prejuízos socioeconômicos; Mortandade animal (inclusive silvestres); grave insegurança alimentar em comunidades rurais; escassez generalizada de água nos reservatórios, rios e poços, requerendo abastecimento emergencial (inclusive em sedes municipais); alto risco de crise energética.</p>
              </td>
          </tr>

              </tbody>
        </table>
        <p  style="font-size: 12px; font-style: italic;"><b>1</b> Exemplos de restrições: rodízio ou racionamento de água, revisão de outorgas para priorizar o abastecimento humano e dessedentação animal, etc.</p>
        <p  style="font-size: 12px; font-style: italic;"><b>2</b> Exemplos de restrições: suspensão de outorgas, apreensão de bombas, etc.</p>
      </mat-card-content>
          
        </mat-card>

        <p style="font-size: 12px; font-style: italic;">
          Estágios de seca, ou categorias, as quais definem a intensidade de seca no mapa do Monitor. 
        </p>
        <p style="font-size: 12px; font-style: italic; margin-bottom: 25px;">
          Tabelas sujeitas a atualizações sem aviso prévio, pois os impactos listados são frequentemente revistos pelas equipes de trabalho, adequando-os à realidade regional. 
        </p>

    </mat-card-content>
</mat-card>
